import React, { lazy, Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { PERMISSIONS } from 'constants/Permissions';
import RoleBasedRouting from "auth/gard/RoleBasedRouting";
import { Route } from "react-router-dom/cjs/react-router-dom.min";

export const AppViews = () => {
    return (
        <Suspense fallback={<Loading cover="content" />}>
            <Switch>
                {/* Users Management - requires USERS.VIEW or ADMINS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.USERS.VIEW, PERMISSIONS.ADMINS.VIEW]}
                    path={`${APP_PREFIX_PATH}/users`}
                    component={lazy(() => import(`./users`))}
                />

                {/* Products Management - requires PRODUCTS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.PRODUCTS.VIEW]}
                    path={`${APP_PREFIX_PATH}/products`}
                    component={lazy(() => import(`./products`))}
                />

                {/* Promo Management - requires PROMO.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.PROMO.VIEW]}
                    path={`${APP_PREFIX_PATH}/promo`}
                    component={lazy(() => import(`./promo`))}
                />

                {/* Category Management - requires CATEGORIES.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.CATEGORIES.VIEW]}
                    path={`${APP_PREFIX_PATH}/category`}
                    component={lazy(() => import(`./category`))}
                />

                {/* Orders Management - requires ORDERS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.ORDERS.VIEW]}
                    path={`${APP_PREFIX_PATH}/orders`}
                    component={lazy(() => import(`./orders`))}
                />

                {/* Finance Management - requires FINANCE.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.FINANCE.VIEW]}
                    path={`${APP_PREFIX_PATH}/finance`}
                    component={lazy(() => import(`views/app-views/finance`))}
                />

                {/* Bonus Management - requires BONUS.DASHBOARD */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.BONUS.DASHBOARD]}
                    path={`${APP_PREFIX_PATH}/bonus`}
                    component={lazy(() => import(`./bonus`))}
                />

                {/* Discounts Management - requires DISCOUNTS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.DISCOUNTS.VIEW]}
                    path={`${APP_PREFIX_PATH}/discounts`}
                    component={lazy(() => import(`./discount`))}
                />

                {/* Media Management - requires MEDIA.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.MEDIA.VIEW]}
                    path={`${APP_PREFIX_PATH}/media`}
                    component={lazy(() => import(`./media`))}
                />

                {/* Reglement Management - requires REGLEMENT.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.REGLEMENT.VIEW]}
                    path={`${APP_PREFIX_PATH}/reglement`}
                    component={lazy(() => import(`./reglement`))}
                />

                {/* Settings Management - requires SETTINGS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.SETTINGS.VIEW]}
                    path={`${APP_PREFIX_PATH}/settings`}
                    component={lazy(() => import(`./settings`))}
                />

                {/* Gift Card Management - requires GIFT_CARDS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.GIFT_CARDS.VIEW]}
                    path={`${APP_PREFIX_PATH}/giftCard`}
                    component={lazy(() => import(`./giftCard`))}
                />

                {/* Challenges Management - requires CHALLENGES.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.CHALLENGES.VIEW]}
                    path={`${APP_PREFIX_PATH}/challenge`}
                    component={lazy(() => import(`./challenges`))}
                />

                {/* Formations/Training - requires FORMATIONS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.FORMATIONS.VIEW]}
                    path={`${APP_PREFIX_PATH}/formations`}
                    component={lazy(() => import(`./formation`))}
                />

                {/* Payments Management - requires PAYMENTS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.PAYMENTS.VIEW]}
                    path={`${APP_PREFIX_PATH}/payments`}
                    component={lazy(() => import(`./payments`))}
                />

                {/* Notifications Management - requires NOTIFICATIONS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.NOTIFICATIONS.VIEW]}
                    path={`${APP_PREFIX_PATH}/notifications`}
                    component={lazy(() => import(`./notifications`))}
                />

                {/* Providers Management - requires PROVIDERS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.PROVIDERS.VIEW]}
                    path={`${APP_PREFIX_PATH}/providers`}
                    component={lazy(() => import(`./providers`))}
                />

                {/* Survey Management - requires SURVEYS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.SURVEYS.VIEW]}
                    path={`${APP_PREFIX_PATH}/survey`}
                    component={lazy(() => import(`./survey`))}
                />

                {/* International Management - requires LANGUAGE_VIEW or CURRENCY_VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.INTERNATIONAL.LANGUAGE_VIEW, PERMISSIONS.INTERNATIONAL.CURRENCY_VIEW]}
                    path={`${APP_PREFIX_PATH}/international`}
                    component={lazy(() => import(`./international`))}
                />

                {/* Countries Management - requires COUNTRIES_SETTINGS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.COUNTRIES_SETTINGS.VIEW]}
                    path={`${APP_PREFIX_PATH}/countries`}
                    component={lazy(() => import(`./countries`))}
                />

                {/* Carriers Management - requires CARRIERS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.CARRIERS.VIEW]}
                    path={`${APP_PREFIX_PATH}/carriers`}
                    component={lazy(() => import(`./carriers`))}
                />

                {/* Dashboard - requires DASHBOARD.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.DASHBOARD.VIEW]}
                    path={`${APP_PREFIX_PATH}/dashboard`}
                    component={lazy(() => import(`views/app-views/home`))}
                />

                {/* Logs Management - requires LOGS.VIEW */}
                <RoleBasedRouting
                    AuthNeeded={[PERMISSIONS.LOGS.VIEW]}
                    path={`${APP_PREFIX_PATH}/logs`}
                    component={lazy(() => import(`./action-logs`))}
                />

                <Route path={`${APP_PREFIX_PATH}/redirect_vote`} component={lazy(() => import(`views/app-views/redirect_vote`))} />

                <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/redirect_vote`} />
            </Switch>
        </Suspense>
    )
}

export default React.memo(AppViews);
